import { useMutation } from '@apollo/client'
import { ApproveGroupClearanceStatus, ApproveGroupClearanceStatusVariables } from '../../types'
import { APPROVE_GROUP_CLEARANCE_STATUS } from './operations'

export const useApproveGroupClearanceStatus = () =>
  useMutation<ApproveGroupClearanceStatus, ApproveGroupClearanceStatusVariables>(
    APPROVE_GROUP_CLEARANCE_STATUS
  )
